import { Observable } from 'rxjs';

import { SelectOption } from '@fcom/common/interfaces';
import { RadioItemGroupOption } from '@fcom/ui-components';
import { type FileUploaderComponent } from '@fcom/ui-components/components/forms/file-uploader/file-uploader.component';
import { type Attachment } from '@fcom/ui-components/components/interfaces';

export enum FormBuilderInput {
  TEXT,
  TEXTAREA,
  FILE_UPLOADER,
  RADIO,
  SELECT,
}

export interface FormBuilderFieldBase {
  allowedFileTypes?: FileUploaderComponent['allowedFileTypes'];
  controlConfig: any[];
  controlName: string;
  customAttachLabel?: string;
  customRequiredLabel?: string;
  disabled?: boolean;
  i18n?: string;
  id?: string;
  maxAttachments?: FileUploaderComponent['maxAttachments'];
  maxSizeInBytes?: FileUploaderComponent['maxSizeInBytes'];
  multiple?: FileUploaderComponent['multiple'];
  note?: string;
  options?: SelectOption[];
  placeHolder?: string;
  prefillFromProfile?: string;
  required?: boolean;
  translationPrefix?: string;
  type: FormBuilderInput;
  uploadService?: FileUploaderComponent['uploadService'];
  values?: RadioItemGroupOption[];
  wordCount?: number;
}

export interface FormBuilderFieldText extends FormBuilderFieldBase {
  type: FormBuilderInput.TEXT;
  placeHolder?: string;
}

export interface FormBuilderFieldTextarea extends FormBuilderFieldBase {
  type: FormBuilderInput.TEXTAREA;
  placeHolder?: string;
  wordCount?: number;
}

export interface FormBuilderFieldRadio extends FormBuilderFieldBase {
  type: FormBuilderInput.RADIO;
  values: RadioItemGroupOption[];
}

export interface FormBuilderFieldSelect extends FormBuilderFieldBase {
  type: FormBuilderInput.SELECT;
  options: SelectOption[];
}

export interface FormBuilderFieldFileUploader extends FormBuilderFieldBase {
  allowedFileTypes?: FileUploaderComponent['allowedFileTypes'];
  customAttachLabel?: string;
  customRequiredLabel?: string;
  disabled?: boolean;
  i18n?: string;
  id?: string;
  maxAttachments?: FileUploaderComponent['maxAttachments'];
  maxSizeInBytes?: FileUploaderComponent['maxSizeInBytes'];
  multiple?: FileUploaderComponent['multiple'];
  type: FormBuilderInput.FILE_UPLOADER;
  uploadService?: FileUploaderComponent['uploadService'];
}

export type FormBuilderField =
  | FormBuilderFieldFileUploader
  | FormBuilderFieldRadio
  | FormBuilderFieldSelect
  | FormBuilderFieldText
  | FormBuilderFieldTextarea;

export interface FormBuilderGroup {
  controlName: string;
  fields: FormBuilderField[];
}

export interface FormBuilderSubmitHandler {
  (formValue: FormBuilderSubmissionData): Observable<unknown>;
}

export type FormBuilderFieldValue = Attachment | Attachment[] | boolean | number | string;

export interface FormBuilderSubmissionData {
  [key: string]: {
    [key: string]: FormBuilderFieldValue;
  };
}
